import React, { useState, useEffect, useRef, useCallback } from "react"
import Slider from "react-slick"

import PropTypes from "prop-types"
import useWindowResize from "@/hooks/useWindowResize"
import missingImage from "@/public/images/image-missing.png"
import zoomClose from "@/styles/images/zoom-close-icon.svg"
import zoomVideoIcon from "@/styles/images/zoom-video-icon.svg"
import tapImageZoom from "@/styles/images/tap-image-zoom.svg"
import { appendPresetToUrl } from "@/utils/helper"

import VideoWrapper from "@/components/VideoWrapper/VideoWrapper"
import { PDP_SLIDER_SIZES } from "@/constants/index"
import { PDP_GALLERY_SLIDER_CONFIG } from "@/components/ImageGallery/v2/constants"

import {
  closeZoomImage,
  getSlickSettings,
  initZoomviewer,
  openModal,
  openModalAction,
  zoomVideoImage,
} from "@/components/ImageGallery/v2/utlis"
import {
  addAnalyticsClickCloseZoom,
  addAnalyticsClickPdpImageVideo,
  addAnalyticsClickSliderImageVideo,
  addAnalyticsClickZoomImage,
  addAnalyticsClickZoomReset,
  addAnalyticsPdpSlider,
  addAnalyticsZoomImageSliderArrow,
} from "@/components/ImageGallery/v2/analytics"

const ImageReel = props => {
  const {
    data = [],
    isModel = false,
    swatchUrl = "",
    staticTexts = {},
    productInfo = {},
    isHorizontal = false,
    galleryStackId = "",
    assetAccountName = "",
    imageClickCounter = 0,
    presetConfigObject = {},
    productGalleryLabel = {},
    initialImgAlt = "",
    initialImgUrl = "",
    pdpDesktopImage = "",
    pdpMobileImage = "",
  } = props

  const iframeContainer = useRef(null)

  const pdpInfo = JSON.parse(productInfo)
  const {
    productInfo: { pdpType: pdpType = [] },
  } = pdpInfo

  const [width] = useWindowResize()
  const [activeIndex, setActiveIndex] = useState(0)
  const [activeImage, setactiveImage] = useState(null)
  const [zoomVideoId, setZoomVideoId] = useState(null)
  const [currentVideoId, setCurrentVideoId] = useState(null)

  const totalImages = isHorizontal ? data.length : 3
  const imageScroll = useRef(null)
  const [imageIndex, setImageIndex] = useState(0)
  const [zoomEntryPoint, setZoomEntryPoint] = useState(null)

  const slickRef = useRef(null)

  const { largeIpadSize, imageReelTitle, mobileSize } = PDP_SLIDER_SIZES

  const resourceCredits =
    productGalleryLabel &&
    productGalleryLabel.resourceCredit_s &&
    productGalleryLabel.resourceCredit_s.match("http") == null
      ? productGalleryLabel.resourceCredit_s
      : ""

  const imageSequence = imageClickCounter ? imageClickCounter + 1 : null
  const getEventInfo = (type, id) => {
    const viewGallery = type === "view gallery"
    let eventInfo = {
      eventAction:
        (viewGallery ? "pdp:product details:" : "pdp:product details:") + type,
      eventName:
        (viewGallery ? "pdp:product details:" : "pdp:product details:") + type,
      eventType: "navigation",
      eventMsg: "n/a",
      eventStatus: "n/a",
      internalLinkName: viewGallery ? type : id || type,
      internalLinkPosition: `pdp${pdpType === "bundle" ? ":bundle" : ""}`,
      internalLinkType: `pdp:${
        viewGallery ? type : (id ? "image " : "") + "navigation"
      }`,
      internalLinkZoneName: "pdp:product details",
      internalLinkURL: "n/a",
      clickInternalLinks: "true",
    }
    if (!viewGallery) {
      eventInfo = { ...eventInfo, imageSequence }
    }
    return eventInfo
  }

  const setIndex = useCallback(() => {
    if (width < largeIpadSize && !isModel) {
      setActiveIndex(0)
    }
  })
  useEffect(() => {
    setIndex()
  }, [data])

  const [kohlerScene, setKohlerScene] = useState(false)
  const pdpImages = data.reduce((acc, ini) => {
    if (
      acc.filter(item => item.assetId === ini.assetId).length === 0 ||
      ini.type === "video"
    ) {
      acc.push(ini)
    }
    return acc
  }, [])
  const imageUrls = pdpImages.map(i => i?.url)
  useEffect(() => {
    const containtsKohlerSceneImage = imageUrls.some(url =>
      url.includes("/PAWEB/")
    )
    if (containtsKohlerSceneImage) {
      setKohlerScene(true)
    }
  }, [imageUrls])

  const isOnePdpImage = initialImgUrl && pdpDesktopImage ? initialImgUrl : ""
  const firstImageForZoom =
    data && pdpImages?.length ? pdpImages[0].assetId : isOnePdpImage

  const beforeChangeHandler = useCallback((current = 0, next = 0) => {
    let arrowLabel = "right"
    if (current > next) {
      arrowLabel = "left"
    } else {
      arrowLabel = "right"
    }
    const pdpImageInfo = pdpImages
      ?.map((item, index) => ({ ...item, index }))
      .find(item => item?.index === next)

    addAnalyticsPdpSlider({
      pdpImageInfo,
      totalImages: pdpImages?.length,
      pdpType,
      arrowLabel,
    })
  })

  const afterChangeHandler = useCallback(currentIndex => {
    setImageIndex(currentIndex)
  })

  const handleOpenModal = useCallback(() => {
    openModal(window.s7viewers)
    window.addEventListener("keydown", handleKey)
  })

  useEffect(() => {
    handleOpenModal()
  }, [])

  let isZoomClick = false
  const slickGotoSlider = sliderNumber => {
    slickRef.current.slickGoTo(sliderNumber)
  }
  const openImageZoom = useCallback(
    (image = "", i = 0, currentImageName = "") => {
      setZoomEntryPoint(imageReelTitle)
      setZoomVideoId("")
      setactiveImage("")
      setactiveImage(image)
      openModalAction(image)

      if (width < mobileSize) {
        slickGotoSlider(i)
      }
      addAnalyticsClickPdpImageVideo({
        index: i + 1,
        mediaType: imageReelTitle,
        imageVideoName: currentImageName,
        totalImages: data?.length,
        pdpType,
        assetId: image,
      })
    }
  )

  const viewGalleryImageClick = useCallback((image = "") => {
    setZoomEntryPoint("view gallery")
    setactiveImage(image)
    openModalAction(image)
  })

  const imageZoomClick = useCallback((image = "", i = 0, imageName = "") => {
    setZoomVideoId("")
    setactiveImage("")
    if (width < 1023) {
      setZoomEntryPoint(imageReelTitle)
    }
    initZoomviewer(image)
    setactiveImage(image)

    addAnalyticsClickSliderImageVideo({
      index: i + 1,
      imageVideoId: image,
      totalImages: data?.length,
      pdpType,
      zoomEntryPoint: zoomEntryPoint,
      imageName,
      imageClick: true,
    })
    setTabIndexGallery()
  })

  const imageZoomVideoClick = useCallback((video = "", i = 0) => {
    if (width < 1023) {
      setZoomEntryPoint(imageReelTitle)
    }
    setactiveImage("")
    setactiveImage(video)
    setZoomVideoId(video)
    setCurrentVideoId(i + 1)
    zoomVideoImage()
    setTabIndexGallery()
  })

  const getVideoInfo = (targetElement = "", index = "", videoId = "") => {
    addAnalyticsClickSliderImageVideo({
      index,
      imageVideoId: videoId,
      totalImages: data?.length,
      pdpType,
      zoomEntryPoint: zoomEntryPoint,
      imageName: targetElement?.videoTitle,
      imageClick: false,
    })
  }

  const imageZoomMobileVideoClick = useCallback((video = "", i = 0) => {
    if (width < 1023) {
      setZoomEntryPoint(imageReelTitle)
    }

    setCurrentVideoId(i + 1)
    setZoomVideoId(video)
    if (width < mobileSize) {
      slickGotoSlider(i)
    }
    openModalAction(video, true)
    setactiveImage(video)
  })

  const closeZoomImageClick = useCallback(() => {
    counter = 0
    zoomOutCounter = 0
    setZoomVideoId(false)
    closeZoomImage()

    const currentImageData = pdpImages
      ?.map((item, index) => ({ ...item, index }))
      .find(item => item?.assetId === activeImage || item?.url === activeImage)

    addAnalyticsClickCloseZoom({
      pdpType,
      zoomEntryPoint,
      currentImageData,
      totalImages: pdpImages?.length,
    })
  })

  const currentImageData = pdpImages
    ?.map((item, index) => ({ ...item, index }))
    .find(item => item?.assetId === activeImage || item?.url === activeImage)

  const s7viewerHandle = useCallback(() => {
    let zoomImageClick = null
    if (iframeContainer?.current && activeImage && zoomEntryPoint) {
      setTimeout(() => {
        const zoomInButtonClick = iframeContainer?.current.querySelector(
          ".s7button.s7zoominbutton"
        )
        const zoomOutButtonClick = iframeContainer?.current.querySelector(
          ".s7button.s7zoomoutbutton"
        )
        const zoomResetButton = iframeContainer?.current.querySelector(
          ".s7button.s7zoomresetbutton"
        )

        zoomImageClick = iframeContainer?.current.querySelector(".s7zoomview")

        if (zoomImageClick) {
          if (width <= largeIpadSize) {
            zoomImageClick.addEventListener(
              "touchstart",
              ev => {
                setTimeout(function () {
                  zoomImageIconAction()
                }, 1000)
              },
              false
            )
          }
        }

        if (zoomImageClick) {
          const delta = 6
          let startX
          let startY

          zoomImageClick.addEventListener("mousedown", function (event) {
            startX = event.pageX
            startY = event.pageY
            isZoomClick = true
          })

          zoomImageClick.addEventListener("mouseup", function (event) {
            const diffX = Math.abs(event.pageX - startX)
            const diffY = Math.abs(event.pageY - startY)
            isZoomClick = true
            if (diffX < delta && diffY < delta) {
              isZoomClick = false
            }
          })
          zoomImageClick.addEventListener("click", zoomImageClickAction, false)
        }
        if (zoomInButtonClick) {
          setTabIndexGallery()
          zoomInButtonClick.addEventListener(
            "click",
            zoomInButtonClickAction,
            false
          )
        }

        if (zoomOutButtonClick) {
          zoomOutButtonClick.addEventListener(
            "click",
            zoomOutButtonClickAction,
            false
          )
        }

        if (zoomResetButton) {
          zoomResetButton.addEventListener(
            "click",
            zoomResetButtonClickAction,
            false
          )
        }
      }, 500)

      const silckSliderNext =
        iframeContainer?.current.querySelector(".slick-next")
      if (silckSliderNext) {
        silckSliderNext.addEventListener("click", e => {
          e.preventDefault()
          addAnalyticsZoomImageSliderArrow({
            pdpType,
            zoomEntryPoint,
            arrowLable: "right",
          })
        })
      }

      const silckSliderPrev =
        iframeContainer?.current.querySelector(".slick-prev")
      if (silckSliderPrev) {
        silckSliderPrev.addEventListener("click", e => {
          e.preventDefault()
          addAnalyticsZoomImageSliderArrow({
            pdpType,
            zoomEntryPoint,
            arrowLable: "left",
          })
        })
      }
    }

    return () => {
      if (iframeContainer?.current) {
        const zoomImageClickBtn =
          iframeContainer?.current.querySelector(".s7zoomview")
        const zoomInButtonClick = iframeContainer?.current.querySelector(
          ".s7button.s7zoominbutton"
        )
        const zoomOutButtonClick = iframeContainer?.current.querySelector(
          ".s7button.s7zoomoutbutton"
        )
        const zoomResetButton = iframeContainer?.current.querySelector(
          ".s7button.s7zoomresetbutton"
        )
        if (zoomImageClickBtn) {
          zoomImageClickBtn?.removeEventListener(
            "click",
            zoomImageClickAction,
            false
          )
        }

        if (zoomInButtonClick) {
          zoomInButtonClick?.removeEventListener(
            "click",
            zoomInButtonClickAction,
            false
          )
        }
        if (zoomOutButtonClick) {
          zoomOutButtonClick?.removeEventListener(
            "click",
            zoomOutButtonClickAction,
            false
          )
        }
        if (zoomResetButton) {
          zoomResetButton?.removeEventListener(
            "click",
            zoomResetButtonClickAction,
            false
          )
        }
      }
    }
  })

  useEffect(
    () => s7viewerHandle(),
    [iframeContainer, zoomEntryPoint, activeImage]
  )

  let counter = 0
  let zoomOutCounter = 0
  const zoomImageClickAction = useCallback(e => {
    const zoomImageClick = iframeContainer?.current.querySelector(".s7zoomview")
    const cursortype = zoomImageClick?.getAttribute("cursortype")

    if (width <= largeIpadSize) {
      isZoomClick = false
    }
    setTimeout(function () {
      setTabIndexGallery()
    }, 1000)
    if (!isZoomClick) {
      setTimeout(function () {
        setTabIndexGallery()
        if (cursortype !== "reset" || cursortype !== "drag") {
          setTabIndexGallery()
          if (cursortype === "zoomin") {
            counter++
            addAnalyticsClickZoomImage({
              pdpType,
              zoomEntryPoint,
              zoomAction: "zoom in",
              currentImageData,
              totalImages: pdpImages?.length,
              counter,
            })
          } else {
            zoomOutCounter++
            addAnalyticsClickZoomImage({
              pdpType,
              zoomEntryPoint,
              zoomAction: "zoom out",
              currentImageData,
              totalImages: pdpImages?.length,
              counter: zoomOutCounter,
            })
          }
        }
      }, 50)
    }
  })

  const zoomInButtonClickAction = useCallback(e => {
    if (width <= largeIpadSize) {
      setTimeout(function () {
        const zoomInImageClick = iframeContainer?.current.querySelector(
          ".s7button.s7zoominbutton"
        )
        const zoomImageOutClick = iframeContainer?.current.querySelector(
          "#s7viewer_zoomOutButton"
        )
        const zoomCursorType = zoomInImageClick.getAttribute("state")
        if (zoomCursorType === "disabled") {
          zoomInImageClick.setAttribute("style", "display: none !important")
          zoomImageOutClick.setAttribute("style", "display: block !important")
        } else {
          zoomInImageClick.setAttribute("style", "display: block !important")
          zoomImageOutClick.setAttribute("style", "display: none !important")
        }
      }, 1000)
    }

    counter++
    addAnalyticsClickZoomImage({
      pdpType,
      zoomEntryPoint,
      zoomAction: "zoom in",
      currentImageData,
      totalImages: pdpImages?.length,
      counter,
    })
  })

  const zoomOutButtonClickAction = useCallback(e => {
    zoomOutCounter++
    addAnalyticsClickZoomImage({
      pdpType,
      zoomEntryPoint,
      zoomAction: "zoom out",
      currentImageData,
      totalImages: pdpImages?.length,
      counter: zoomOutCounter,
    })
    if (width <= largeIpadSize) {
      setTimeout(function () {
        const zoomInImageClick = iframeContainer?.current.querySelector(
          ".s7button.s7zoominbutton"
        )
        const zoomImageOutClick = iframeContainer?.current.querySelector(
          "#s7viewer_zoomOutButton"
        )
        const zoomCursorType = zoomImageOutClick.getAttribute("state")
        if (zoomCursorType === "disabled") {
          zoomInImageClick.setAttribute("style", "display: block !important")
          zoomImageOutClick.setAttribute("style", "display: none !important")
        } else {
          zoomInImageClick.setAttribute("style", "display: none !important")
          zoomImageOutClick.setAttribute("style", "display: block !important")
        }
      }, 1000)
    }
  })

  const zoomResetButtonClickAction = useCallback(e => {
    counter = 0
    zoomOutCounter = 0

    addAnalyticsClickZoomReset({
      pdpType,
      zoomEntryPoint,
      currentImageData,
      totalImages: pdpImages?.length,
    })
  })

  const lastTabIndex = 0
  let currentIndex = 90

  const handleKey = () => {
    window.addEventListener(
      "focusin",
      function () {
        currentIndex = document.activeElement.tabIndex
      },
      true
    )

    let curIndex = currentIndex
    if (curIndex == lastTabIndex) {
      curIndex = 90
    }
    const tabbables = document.querySelectorAll(".image-overlay")

    for (let i = 0; i < tabbables.length; i++) {
      if (tabbables[i].tabIndex == curIndex) {
        tabbables[i].focus()
        break
      }
    }
  }

  const setTabIndexGallery = () => {
    const zoomInButtonClick = iframeContainer?.current.querySelector(
      ".s7button.s7zoominbutton"
    )
    const zoomOutButtonClick = iframeContainer?.current.querySelector(
      ".s7button.s7zoomoutbutton"
    )
    const zoomResetButton = iframeContainer?.current.querySelector(
      ".s7button.s7zoomresetbutton"
    )
    if (zoomInButtonClick) {
      zoomInButtonClick.setAttribute("tabindex", "96")
      zoomOutButtonClick.setAttribute("tabindex", "97")
      zoomResetButton.setAttribute("tabindex", "98")
    }
  }

  const zoomImageIconAction = () => {
    const zoomInImageClick = iframeContainer?.current.querySelector(
      ".s7button.s7zoominbutton"
    )
    const zoomImageOutClick = iframeContainer?.current.querySelector(
      "#s7viewer_zoomOutButton"
    )
    const zoomCursorType = zoomInImageClick.getAttribute("state")
    if (zoomCursorType === "disabled") {
      zoomOutCounter++
      addAnalyticsClickZoomImage({
        pdpType,
        zoomEntryPoint,
        zoomAction: "zoom out",
        currentImageData,
        totalImages: pdpImages?.length,
        counter: zoomOutCounter,
      })
      zoomInImageClick.setAttribute("style", "display: none !important")
      zoomImageOutClick.setAttribute("style", "display: block !important")
    } else {
      counter++
      addAnalyticsClickZoomImage({
        pdpType,
        zoomEntryPoint,
        zoomAction: "zoom in",
        currentImageData,
        totalImages: pdpImages?.length,
        counter,
      })

      zoomInImageClick.setAttribute("style", "display: block !important")
      zoomImageOutClick.setAttribute("style", "display: none !important")
    }
  }

  const renderTotalImages = () =>
    data && totalImages && data.slice(0, totalImages)?.length ? (
      pdpImages.slice(0, totalImages).map((element, i) => {
        const isVideo = element.type === "video"
        return (
          <li
            elementid={element.assetId}
            id={i}
            key={`gallery-zoom-image-${i}`}
            className={`pdp-image-reel__image-list ${
              isModel ? "pdp-image-reel__modal-image" : ""
            } ${
              activeIndex === i && width < largeIpadSize
                ? "pdp-image-reel__active-image"
                : ""
            }`}
            role="listitem"
            aria-label={element.label}
            onClick={() => {
              if (kohlerScene) {
                !isVideo
                  ? openImageZoom(element.assetId, i, element?.label)
                  : imageZoomMobileVideoClick(element.url, i)
              } else {
                console.error("zoom disabled")
              }
            }}
          >
            {!element.type ? (
              <div
                className={`${
                  kohlerScene ? "pdp-image-reel__image-display" : ""
                }`}
                key={`gallery-zoom-image-${i}`}
              >
                <img
                  role="button"
                  onError={e => (e.target.src = missingImage?.src)}
                  src={appendPresetToUrl(
                    assetAccountName,
                    swatchUrl,
                    element.assetId,
                    width,
                    presetConfigObject,
                    true,
                    element.url
                  )}
                  alt={element.label}
                  tabIndex={0}
                  className={`${i === 0 ? "print" : "no-print"} ${
                    !element.url.includes("/PAWEB/") ? "no-preset" : ""
                  }`}
                />
                {kohlerScene ? (
                  <img
                    role="button"
                    src={tapImageZoom?.src}
                    alt={element.label}
                    tabIndex={0}
                    className="tap-image-zoom"
                  />
                ) : (
                  ""
                )}
              </div>
            ) : (
              <div
                className="pdp-video-wrapper"
                key={`gallery-zoom-image-${i}`}
              >
                {width < 971 ? (
                  <VideoWrapper
                    thumb
                    alt={element.label}
                    videoId={element.url}
                    imageSequence={imageSequence}
                    playThumb={width < largeIpadSize && !isModel}
                    width="100%"
                    height="350"
                    getVideoInfo={getVideoInfo}
                  />
                ) : (
                  <VideoWrapper
                    videoId={element.url}
                    width="100%"
                    height="550"
                  />
                )}
              </div>
            )}
          </li>
        )
      })
    ) : (
      <li
        className="pdp-image-reel__image-list"
        onClick={() => openImageZoom(initialImgUrl)}
      >
        <div
          className={`${kohlerScene ? "pdp-image-reel__image-display" : ""}`}
        >
          {initialImgUrl && pdpDesktopImage ? (
            <picture>
              <source
                srcSet={pdpMobileImage
                  .replace("/}", `/${initialImgUrl}}`)
                  .replace("&fmt=webp", "")}
                media="(max-width: 768px)"
              />
              <source
                srcSet={pdpDesktopImage
                  .replace("/}", `/${initialImgUrl}}`)
                  .replace("&fmt=webp", "")}
                media="(min-width: 769px)"
              />
              <img
                role="button"
                src={pdpMobileImage
                  .replace("/}", `/${initialImgUrl}}`)
                  .replace("&fmt=webp", "")}
                alt={initialImgAlt}
                tabIndex="0"
                className="print"
                fetchpriority="high"
              />
            </picture>
          ) : (
            <p className="shimmer-loading__para shimmer height-400" />
          )}
        </div>
      </li>
    )
  const images = pdpImages.map(i => i.assetId)
  const [currentImageIndex, setCurrentImageIndex] = useState(0)
  const touchStartX = useRef(0)
  const touchEndX = useRef(0)
  const multiTouchRef = useRef(0)

  const handleSwipe = useCallback(() => {
    const swipeDistance = touchStartX.current - touchEndX.current
    const swipeThreshold = 50
    if (swipeDistance > swipeThreshold) {
      showNextImage()
    } else if (swipeDistance < -swipeThreshold) {
      showPreviousImage()
    }
  })

  const showNextImage = useCallback(() => {
    setCurrentImageIndex(prevIndex => {
      const nextIndex = (prevIndex + 1) % images.length
      initZoomviewer(images[nextIndex])
      setactiveImage(images[nextIndex])
      return nextIndex
    })
  })
  const showPreviousImage = useCallback(() => {
    setCurrentImageIndex(prevIndex => {
      const prevAdjustedIndex = (prevIndex - 1 + images.length) % images.length
      initZoomviewer(images[prevAdjustedIndex])
      setactiveImage(images[prevAdjustedIndex])
      return prevAdjustedIndex
    })
  })
  const touchTimeoutRef = useRef(null)
  const handleTouchStart = e => {
    touchStartX.current = e.changedTouches[0].screenX
    if (touchTimeoutRef.current) {
      clearTimeout(touchTimeoutRef.current)
    }
    touchTimeoutRef.current = setTimeout(() => {
      if (e.touches.length > 1) {
        multiTouchRef.current = 2
      }
    }, 100)
  }
  const handleTouchEnd = e => {
    touchEndX.current = e.changedTouches[0].screenX
    if (multiTouchRef.current < 2) {
      handleSwipe()
    }
    if (touchTimeoutRef.current) {
      clearTimeout(touchTimeoutRef.current)
      touchTimeoutRef.current = null
    }
  }

  const mobileImageSlide = useCallback(() => {
    const ZoomViewerElement = document.getElementById("s7viewer")
    ZoomViewerElement.addEventListener("touchstart", handleTouchStart)
    ZoomViewerElement.addEventListener("touchend", handleTouchEnd)
    return () => {
      ZoomViewerElement.removeEventListener("touchstart", handleTouchStart)
      ZoomViewerElement.removeEventListener("touchend", handleTouchEnd)
    }
  })

  useEffect(() => {
    mobileImageSlide()
  }, [])

  return (
    <>
      <div
        className={`image-overlay ${zoomVideoId ? "video-open" : ""}`}
        id="imageoverlay"
        tabIndex={90}
        role="dialog"
        aria-labelledby="gallery-test"
      >
        <span
          className="close-zoom-image"
          onClick={closeZoomImageClick}
          tabIndex={91}
          role="dialog"
          aria-labelledby="myLargeModalLabel1"
        >
          <img src={zoomClose?.src} role="button" alt="close" tabIndex={152} />
        </span>
        <div className="popup-content" tabIndex={93}>
          <div className="iframe-container" ref={iframeContainer}>
            <div id="s7viewer" tabIndex={99}></div>
            {zoomVideoId ? (
              <div className="zoom-video" id="zoomVideo">
                <VideoWrapper
                  videoId={zoomVideoId}
                  width="100%"
                  playVideoClick={true}
                  index={currentVideoId}
                  totalPdpImages={data?.length}
                  zoomEntryPoint={zoomEntryPoint}
                  getVideoInfo={getVideoInfo}
                />
              </div>
            ) : null}
            <div
              className="gallery"
              id="gallery-test"
              tabIndex={150}
              role="dialog"
              aria-labelledby="myLargeModalLabel3"
            >
              <Slider
                key="slider-zoom-gallery"
                {...getSlickSettings(width)}
                ref={ref => (slickRef.current = ref)}
                tabIndex={151}
              >
                {data && pdpImages?.length ? (
                  pdpImages.map((element, i) => (
                    <>
                      {!element.type ? (
                        <div
                          className={`image-wrapper ${
                            element.assetId === activeImage ? "imageActive" : ""
                          }`}
                          key={`zoom-image-${i}`}
                        >
                          <img
                            role="button"
                            onError={e => (e.target.src = missingImage?.src)}
                            src={appendPresetToUrl(
                              assetAccountName,
                              swatchUrl,
                              element.assetId,
                              width,
                              presetConfigObject,
                              true
                            )}
                            alt={element.label}
                            tabIndex={`10${+i}`}
                            onClick={() =>
                              imageZoomClick(element.assetId, i, element?.label)
                            }
                          />
                        </div>
                      ) : (
                        <div
                          key={`zoom-video-${i}`}
                          onClick={() => imageZoomVideoClick(element.url, i)}
                          className={`image-wrapper zoom-video-section ${
                            element.url === activeImage ? "imageActive" : ""
                          }`}
                        >
                          <VideoWrapper
                            thumb
                            videoId={element.url}
                            getVideoInfo={getVideoInfo}
                            index={i}
                            totalPdpImages={data?.length}
                            zoomEntryPoint={zoomEntryPoint}
                          />
                          <span className="zoom-video-icon">
                            <img
                              src={zoomVideoIcon?.src}
                              alt="zoom video"
                              tabIndex={110 + i}
                            />
                          </span>
                        </div>
                      )}
                    </>
                  ))
                ) : (
                  <div className="image-wrapper  imageActive">
                    {initialImgUrl && pdpDesktopImage ? (
                      <picture>
                        <source
                          srcSet={pdpMobileImage
                            .replace("/}", `/${initialImgUrl}}`)
                            .replace("&fmt=webp", "")}
                          media="(max-width: 768px)"
                        />
                        <source
                          srcSet={pdpDesktopImage
                            .replace("/}", `/${initialImgUrl}}`)
                            .replace("&fmt=webp", "")}
                          media="(min-width: 769px)"
                        />
                        <img
                          role="button"
                          src={pdpMobileImage
                            .replace("/}", `/${initialImgUrl}}`)
                            .replace("&fmt=webp", "")}
                          alt={initialImgAlt}
                          tabIndex="105"
                          className="print"
                          fetchpriority="high"
                          onClick={() =>
                            imageZoomClick(initialImgUrl, 0, initialImgAlt)
                          }
                        />
                      </picture>
                    ) : (
                      <p className="shimmer-loading__para shimmer height-400" />
                    )}
                  </div>
                )}
              </Slider>
            </div>
          </div>
        </div>
      </div>

      <div className="pdp-image-reel">
        <div
          className={`${
            isHorizontal ? "pdp-image-reel__horizontal-gallery" : ""
          }`}
        >
          <div
            ref={imageScroll}
            className={`pdp-image-reel__image-stack-view ${
              width < largeIpadSize && !isModel
                ? "pdp-image-reel__slider-container"
                : ""
            }`}
          >
            <ul
              className={`pl-0 list-inline pdp-image-reel__image-stack-list`}
              role="list"
              id={galleryStackId}
              onClick={e => e.stopPropagation}
            >
              {width < largeIpadSize ? (
                <Slider
                  key="pdpSliderKey"
                  {...PDP_GALLERY_SLIDER_CONFIG}
                  afterChange={afterChangeHandler}
                  beforeChange={beforeChangeHandler}
                >
                  {renderTotalImages()}
                </Slider>
              ) : (
                renderTotalImages()
              )}

              {!isHorizontal &&
                data &&
                data.length > 3 &&
                width >= largeIpadSize && (
                  <li id="4" role="listitem">
                    <div className="pdp-image-reel__image-view">
                      <button
                        className="pdp-image-reel__link-more gbh-data-layer"
                        data-gbh-data-layer={JSON.stringify(
                          getEventInfo("view gallery")
                        )}
                        data-gbh-data-layer-custom={productInfo || null}
                        onClick={() => viewGalleryImageClick(firstImageForZoom)}
                      >
                        {staticTexts.viewGallery}
                      </button>
                    </div>
                  </li>
                )}
            </ul>
            {width < largeIpadSize && !isModel && totalImages > 1 && (
              <p className="pdp-image-reel__slider-count">
                {imageIndex + 1} of {pdpImages?.length}
              </p>
            )}
          </div>
        </div>
      </div>
      {resourceCredits && isModel && (
        <p className="pdp-image-reel__photo-credit">{resourceCredits}</p>
      )}
    </>
  )
}

ImageReel.propTypes = {
  data: PropTypes.arrayOf(PropTypes.any).isRequired,
  staticTexts: PropTypes.object,
  productInfo: PropTypes.string,
  updateImageClickCounter: PropTypes.func,
  imageClickCounter: PropTypes.number,
}

export default React.memo(ImageReel)
